import { Context2DTileMap } from "core/map";
import { TileNavigationState } from "core/tiles";
export class SurfaceTexture extends Context2DTileMap {
    constructor(tile, display) {
        super(display, new TileNavigationState(tile.geoBounds?.center, tile.address.levelOfDetail));
        this._tile = tile;
    }
    get tile() {
        return this._tile;
    }
}
//# sourceMappingURL=texture.map.js.map